import { getApiUrl } from "@utils/baseUrl";
import axios from "axios";
import { toast } from "react-toastify";

const savedSearchAPI = {
  saveSearch: getApiUrl("saveSearch"),
  intelligentAPI: getApiUrl("intelligentEmailAlert"),
  updateEmailAlert: getApiUrl("updateEmailAlertStatus"),
  usersSavedSearchDetails: getApiUrl("usersSavedSearchDetails"),
  getActiveUserOrganisationWise: getApiUrl("getActiveUserOrganisationWise"),
};

export const getActiveUserOrganisation = async () => {
  const params = {
    productName: "intel",
  };
  try {
    const { data } = await axios.get(savedSearchAPI.getActiveUserOrganisationWise, { params });
    return data;
  } catch (error) {
    toast.error("Something went wrong. Please try again later!");
    return [];
  }
};

export const getEmailAlertFrequency = async ({ redirectionId }) => {
  try {
    const { data } = await axios.get(savedSearchAPI.intelligentAPI);
    const result = data?.data;
    const measurable_parameters = result[redirectionId] && result[redirectionId].measurable_parameters && result[redirectionId].measurable_parameters.find((item) => item === "shipments");
    const frequency = result[redirectionId] && result[redirectionId].alert_type && result[redirectionId].alert_type.find((item) => item.value === "7");
    return { result, measurable_parameters, frequency };
  } catch {
    toast.error("Something went wrong. Please try again later!");
  }
};

export const checkEmailAlert = async () => {
  try {
    const { data } = await axios.get(savedSearchAPI.usersSavedSearchDetails);
    return { totalAlerts: data?.saved_search_name, is_gif_alert: data?.is_gif_alert };
  } catch (error) {
    toast.error("Something went wrong. Please try again later!");
  }
};

export const saveSearchCall = async (payload) => {
  try {
    const { data } = await axios.post(savedSearchAPI.saveSearch, payload);
    return data;
  } catch (error) {
    return error;
  }
};

export const updateEmailAlert = async (payload) => {
  const apiUrl = savedSearchAPI.updateEmailAlert;
  const { data } = await axios.post(apiUrl, payload);
  return data;
};
